/*
 * Weglot + selector de idioma de Shopify.
 * Weglot traduce con prefijo de URL (/en/...), pero el formulario nativo de
 * localización de Shopify cambia el idioma por POST /localization y no se lleva
 * bien con él. Aquí el selector sólo cambia el prefijo de la URL y la selección
 * del idioma se deduce de ese prefijo.
 */
(function () {
	var select = document.querySelector('#LocalizationModal--locale-form select[name="locale_code"]');
	if (!select) return;

	var form = select.form;
	// Español es el idioma original de Weglot: va sin prefijo (/), aunque Shopify lo sirva como /es
	var defaultLocale = 'es';
	var locales = Array.prototype.map.call(select.options, function (o) { return o.value; });
	var prefixRegex = new RegExp('^/(' + locales.join('|') + ')(?=/|$)', 'i');

	function currentLocale() {
		var m = window.location.pathname.match(prefixRegex);
		return m ? m[1].toLowerCase() : defaultLocale;
	}

	function pathFor(locale) {
		var path = window.location.pathname.replace(prefixRegex, '') || '/';
		if (locale !== defaultLocale) path = '/' + locale + (path === '/' ? '' : path);
		return path + window.location.search + window.location.hash;
	}

	function syncSelection() {
		var locale = currentLocale();
		select.value = locale;
		var label = select.options[select.selectedIndex];
		if (!label) return;
		var text = label.textContent.trim();
		text = text.charAt(0).toUpperCase() + text.slice(1).toLowerCase();
		document.querySelectorAll('[data-modal="#LocalizationModal--locale"] .thb-localization-forms__button, #jw_pie_pie-idioma').forEach(function (btn) {
			btn.textContent = text;
		});
	}

	form.addEventListener('submit', function (event) {
		event.preventDefault();
		event.stopImmediatePropagation();
		var target = pathFor(select.value);
		if (target === window.location.pathname + window.location.search + window.location.hash) return;
		window.location.assign(target);
	}, true);

	syncSelection();
	window.addEventListener('pageshow', syncSelection);
})();
